export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9112.a90de774.jpg";